/** Si el tema que se está viendo es el oscuro, y sigue sus cambios en vivo.
 *
 * Hay dos formas de cambiarlo: el botón «Tema» (que escribe `data-tema` en la raíz) y el modo
 * del sistema (`prefers-color-scheme`). Se escuchan las dos; antes se leía una vez al abrir la
 * página y el editor se quedaba con el tema viejo hasta recargar.
 */
import { useSyncExternalStore } from 'react'

function oscuro(): boolean {
  const forzado = document.documentElement.getAttribute('data-tema')
  if (forzado) return forzado === 'oscuro'
  return window.matchMedia('(prefers-color-scheme: dark)').matches
}

function suscribir(avisar: () => void): () => void {
  const medios = window.matchMedia('(prefers-color-scheme: dark)')
  const observador = new MutationObserver(avisar)
  observador.observe(document.documentElement, { attributes: true, attributeFilter: ['data-tema'] })
  medios.addEventListener('change', avisar)
  return () => {
    observador.disconnect()
    medios.removeEventListener('change', avisar)
  }
}

export function useTemaOscuro(): boolean {
  return useSyncExternalStore(suscribir, oscuro, () => false)
}
